<alpha-prescription-printer
  #printer
  [mode]="'live'"
  [zoom]="100"
  [showHeader]="true"
>
  <!-- Project your custom component directly into the Interactive Doctor Portal Frame -->
  <app-edit-prescription doctorPortal></app-edit-prescription>
</alpha-prescription-printer>